<template>
  <div class="d-flex flex-column flex-column-fluid  qbank-section">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-6 py-lg-6">
      <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
            منصة أكاديميا Academia
          </h1>
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <li class="breadcrumb-item text-muted">
              <a href="#" class="text-muted text-hover-primary">الصفحة الرئيسية</a>
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">بنوك الأسئلة</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <button @click="$router.go(-1)" class="btn btn-light"
            style="font-weight: 600;padding: 8px 20px;margin-left: 15px;background: #d7d7d745;">
            رجوع <i class="fa fa-arrow-left" style="color: #07c232; margin-right: 10px"></i></button>
        </div>
      </div>
    </div>
    <!-- Content -->

    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div v-if="isLoading == true"
          style="font-weight: 800;border-radius: 10px;padding: 50px;font-size: large;text-align: center;background: #73737326;"
          class="loader text-success">
          جاري التحميل
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <div v-if="isLoggedIn == false && isLoading == false" class="col-12">
          <div class="card text-center p-5 not-login">
            <span class="icon"><i class="bi bi-person-badge"></i></span>
            <h3 class="mb-4">يرجى تسجيل الدخول للإستمرار </h3>
            <span>
              <a href="login" class="btn btn-success">
                تسجيل الدخول <i class="fa fa-sign-in"></i>
              </a>
            </span>
          </div>
        </div>
        <div class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div class="col-md-12" v-if="isLoading == false && isLoggedIn == true">
            <div class="row">

              <div class="col-xl-12 mb-xl-10">
                <!--begin::List widget 20-->
                <div class="card h-xl-100">
                  <!--begin::Header-->
                  <div class="card-header border-0 pt-5">
                    <h3 class="card-title align-items-start flex-column">
                      <span class="card-label fw-bold text-dark"> إختباراتي</span>
                      <span class="text-muted mt-1 fw-semibold fs-7">قائمة بكل الإختبارات المتاحة في الإختبار</span>
                    </h3>
                    <!--begin::Toolbar-->

                    <!--end::Toolbar-->
                  </div>
                  <!--end::Header-->
                  <!--begin::Body-->
                  <!--begin::Body-->
                  <div class="card-body pt-6">
                    <div class="m-2 mb-5">
                      <a :href="`/qbank-subscribe?id=${this.subscriptionId}`" class="btn btn-success btn-block"
                        style="font-weight: 800;width: 100%;background-color: #07c232;">
                        إنشاء إختبار جديد <i class="fa-solid fa-plus"></i>
                      </a>
                    </div>

                    <!-- عرض الاختبارات -->
                    <div v-if="tests && tests.length">
                      <div class="row">
                        <div class="col-md-6 col-lg-4 mb-4" v-for="(test, index) in tests" :key="test.id">
                          <div class="card h-100 shadow-sm border-0" style="border:1px solid #07c232 !important;">
                            <div class="card-body">
                              <h5 class="card-title text-success d-flex justify-content-between align-items-center">
                                <b>{{ test.name }}</b>
                                <div class="dropdown w-30">
                                  <a v-if="test.quiz_mode == 1 && (test.status == 'paused' || test.status == 'active')"
                                    class="seprate-btn"
                                    :href="`qbank-quiz-tutor?qref=${test.id}&num=${test.answered_questions_count}&mode=${test.quiz_mode}&total=${test.total_questions_count}`">
                                    &nbsp;&nbsp;&nbsp;&nbsp; إستمرار </a>
                                  <a v-if="test.quiz_mode == 2 && (test.status == 'paused' || test.status == 'active')"
                                    class="seprate-btn"
                                    :href="`qbank-quiz-timed?qref=${test.id}&num=${test.answered_questions_count}&mode=${test.quiz_mode}&total=${test.total_questions_count}`">
                                    &nbsp;&nbsp;&nbsp;&nbsp; إستمرار</a>
                                  <a v-if="test.status == 'completed'" class="seprate-btn" style="cursor: pointer;"
                                    @click="openModal(test)">مراجعة الإختبار</a>
                                  <br>
                                  <button class="btn btn-secondary btn-sm w-100 dropdown-toggle mt-2" type="button"
                                    id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    المزيد
                                  </button>
                                  <ul class="dropdown-menu w-100" aria-labelledby="dropdownMenuButton1">
                                    <!--<li v-if="test.status == 'paused'">
                                      <a v-if="test.quiz_mode == 1" class="dropdown-item"
                                        :href="`qbank-quiz-tutor?qref=${test.id}&num=${test.answered_questions_count}&mode=${test.quiz_mode}&total=${test.total_questions_count}`">استمرار</a>
                                      <a v-if="test.quiz_mode == 2" class="dropdown-item"
                                        :href="`qbank-quiz-timed?qref=${test.id}&num=${test.answered_questions_count}&mode=${test.quiz_mode}&total=${test.total_questions_count}`">استمرار</a>
                                    </li>
                                    <li v-if="test.status == 'completed'">
                                      <a class="dropdown-item"
                                        :href="`qbank-quiz-review?qref=${test.id}&num=${test.answered_questions_count}&mode=${test.quiz_mode}&total=${test.total_questions_count}`">مراجعة</a>
                                    </li>-->
                                    <li v-if="test.status == 'completed'">
                                      <a class="dropdown-item" :href="`qbank-summary?qbank=${test.id}`">تحليل
                                        الإختبار</a>
                                    </li>
                                    <li>
                                      <span class="dropdown-item" data-bs-toggle="modal" style="cursor: pointer;"
                                        data-bs-target="#show-note-modal" @click.prevent="showNotes(test.id)">عرض
                                        الملاحظات</span>
                                    </li>
                                    <li>
                                      <span class="dropdown-item" data-bs-toggle="modal" style="cursor: pointer;"
                                        data-bs-target="#show-report-modal" @click.prevent="showReports(test.id)">عرض
                                        البلاغات</span>
                                    </li>
                                    <li>
                                      <span class="dropdown-item" data-bs-toggle="modal"
                                        @click.prevent="changeMode(test.id)" style="cursor: pointer;"
                                        data-bs-target="#changemode-modal"> تغيير نوع الإختبار</span>
                                    </li>
                                    <li>
                                      <span class="dropdown-item" data-bs-toggle="modal"
                                        @click.prevent="changeName(test.id, test.name)" style="cursor: pointer;"
                                        data-bs-target="#changename-modal"> تعديل الإسم</span>
                                    </li>
                                  </ul>
                                </div>
                              </h5>
                              <p class="mb-2">
                                <strong>نوع الاختبار: </strong>
                                <span :class="{
                                  'badge bg-primary': test.quiz_mode === 1,
                                  'badge bg-info': test.quiz_mode === 2,
                                }">
                                  {{ test.quiz_mode === 1 ? "وضع الدراسة" : "وضع الإختبار" }}
                                </span>
                              </p>

                              <p class="mb-2">
                                <strong>الحالة: </strong>
                                <span :class="{
                                  'badge bg-success': test.status === 'completed',
                                  'badge bg-secondary text-dark': test.status !== 'completed',
                                }">
                                  {{ test.status === 'completed' ? 'مكتمل' : 'متوقف' }}
                                </span>
                              </p>

                              <p><strong>التقدم: </strong> {{ test.progress }}%</p>
                              <p><strong>الإجابات الصحيحة: </strong> {{ test.correct_answers_count }}/{{
                                test.total_questions_count }}</p>
                              <p><strong>الإجابات المتبقية: </strong> {{ test.unanswered_questions.length }}</p>
                              <p><strong>مدة الاختبار: </strong> {{ test.total_time }} ثانية</p>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-else>
                      <p class="text-muted text-center">لا توجد اختبارات متاحة لهذا الاشتراك.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--begin::Col-->

    <!--end::Col-->
    <div class="modal fade" id="reviewModal" tabindex="-1" aria-labelledby="reviewModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="reviewModalLabel"> مراجعة الإختبار</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="d-grid gap-2">
              <a :href="reviewLink" class="btn btn-success bg-success">مراجعة الأسئلة</a>
              <a :href="summaryLink" class="btn btn-success bg-success">تحليل الأداء</a>
              <hr>
              <a class="btn btn-danger" data-bs-dismiss="modal"
                style="font-weight: 700;color: #bd0000;background-color: #ff00006b !important;"> إلغاء</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal Structure -->


  <Notes ref="notesRef" />
  <Reports ref="reportsRef" />

  <ChangeType />
  <ChangeName />
</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";
import Notes from "./Notes.vue";
import Reports from "./Reports.vue";

import ChangeType from "./ChangeType.vue";
import ChangeName from "./ChangeName.vue";

export default {
  name: "QuizList",
  components: {
    Notes,
    Reports,
    ChangeType,
    ChangeName
  },
  data() {
    return {
      categories: [],
      subCategories: [],
      qbankNotes: [],
      reviewLink: '',
      summaryLink: '',
      qbankId: '',
      isLoading: true,
      subscriptionId: this.$route.query.subscriptionId,
      token: localStorage.getItem("access_token"),
      courseCount: 0,
      isLoggedIn: false,
      walletBalance: 0,
      catImagePath: baseUrl + "/images/category/",
      defaultImage: "/assets/img/acad-icon.png",
      student: {},
      loadingCategories: true, // Loading state for categories
      loadingCourses: true, // Loading state for courses
      loadingBalance: true, // Loading state for wallet balance
      currentStep: 1, // بداية في الخطوة 1
      selectedOption: "", // البيانات للـ select box
      textInput: "", // البيانات للـ input text
      numberInput: "", // البيانات للـ input number
      isChecked: false, // البيانات للـ checkbox
    };
  },

  mounted() {
    this.fetchSubscriptionDetails(this.subscriptionId);
  },
  methods: {
    toggleDropdown() {
      const dropdownMenu = document.querySelector("#custom-dropdown .dropdown-menu");
      // تبديل العرض بين إظهار وإخفاء
      if (dropdownMenu.style.display === "block") {
        dropdownMenu.style.display = "none";
      } else {
        dropdownMenu.style.display = "block";
      }
    },
    async showNotes(qbankNoteId) {
      document.getElementById("qbankNoteId").value = qbankNoteId;
      this.$refs.notesRef.showNotes()
    },
    async showReports(qbankReportId) {
      document.getElementById("qbankReportId").value = qbankReportId;
      this.$refs.reportsRef.showReports()
    },
    formatDate(date) {
      return new Date(date).toLocaleString("ar-EG", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },
    async fetchNotes(questionBank) {

    },
    openModal(test) {
      // إعداد الروابط للمراجعة والتحليل
      this.reviewLink = `qbank-quiz-review?qref=${test.id}&num=${test.answered_questions_count}&mode=${test.quiz_mode}&total=${test.total_questions_count}`;
      this.summaryLink = `qbank-summary?qbank=${test.id}`;

      // إظهار المودال
      const modal = new bootstrap.Modal(document.getElementById('reviewModal'));
      modal.show();
    },
    async changeMode(questionBank) {
      document.getElementById("qbankId").value = questionBank;
    },
    async changeName(questionBank, qbankName) {
      document.getElementById("qbankId").value = questionBank;
      document.getElementById("qName").value = qbankName;

    },
    async fetchSubscriptionDetails(subscriptionId) {
      try {
        const response = await fetch(
          `${apiUrl}/subscription-plans/${subscriptionId}/qbanks`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.subscriptionId = subscriptionId;
        if (response.ok) {
          const data = await response.json();
          this.tests = data.data;
          this.isLoading = false;
          this.isLoggedIn = true;

        } else {
          console.error("Failed to fetch subscription details");
        }
      } catch (error) {
        console.error("Error fetching subscription details:", error);
      }
    },
  },
};
</script>

<style scoped>
.bg-success {
  background-color: #07c232 !important;
}

.text-success {
  color: #07c232 !important;
}
</style>
